import ResultsListing from './ResultsListing';

export { type ResultsListingProps } from './ResultsListing';
export default ResultsListing;
